var geo_options = {
  enableHighAccuracy: true, 
  maximumAge        : 0, 
  timeout           : 27000
};

export function _getCurrentPosition() { // accepts a request
  return function (onError, onSuccess) { // and callbacks
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        onSuccess(position);
      }, null, geo_options);
    } else {
      onError();
    }

    // Return a canceler, which is just another Aff effect.
    return function (cancelError, cancelerError, cancelerSuccess) {
      cancelerSuccess(); // invoke the success callback for the canceler
    };
  };
};

export function _watchCurrentPosition(onSuccess) { // and callbacks
    return function (onError) {
      console.log("Started.");
      return function () { // accepts a request
        if (navigator.geolocation) {
          console.log("GPS Supported.");
          navigator.geolocation.watchPosition(function(position) {
            onSuccess(position)();
          }, function(err) {
            console.log(err);
            onError(err.code)();
          } , geo_options);
        } else {
          console.log("Not supported.");
        }
      }
    }
  }
